<template>
  <div class="tender-status__time-left" v-if="isStatusOpen">
    <span class="tender-title__subtitle">{{ $t('tender-details.time-left') }}</span>
    <BaseTag
      v-if="daysBeforeClosing && daysBeforeClosing !== 0"
      icon="clock"
      preset="soft"
      :tone="getClosingCountdownTone(daysBeforeClosing)"
    >
      {{ timeLeft }}
    </BaseTag>
    <BaseTag v-else icon="clock" preset="soft" tone="destructive"> - </BaseTag>
  </div>
</template>

<script>
import BaseTag from '@/components/base/BaseTag.vue';
import { getClosingCountdownTone } from '@/util/tender-closing-countdown';
import { getDhm, getHm } from '@/util/date-util';

export default {
  name: 'TenderTimeLeft',
  props: {
    status: String,
    daysBeforeClosing: Array,
    useShortDate: { type: Boolean, default: false },
  },
  components: {
    BaseTag,
  },
  computed: {
    isStatusOpen() {
      return this.status === 'active';
    },
    timeLeft() {
      if (this.daysBeforeClosing[0] < 1) {
        return getHm(this.daysBeforeClosing);
      }

      if (this.useShortDate) {
        return getDhm(this.daysBeforeClosing).split(' ')[0];
      }

      return getDhm(this.daysBeforeClosing);
    },
  },
  methods: {
    getClosingCountdownTone,
  },
};
</script>
